/**
 * Created by casteloyee on 2017/7/20.
 */
import React from 'react';
import API_URL from '../../common/url';
import SearchSelect from '../common/SearchSelect';

class SiteSearchInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    };

    parserData = dt => {
        if (dt.data && dt.data.siteList && dt.data.siteList.count > 0) {
            const data = dt.data.siteList.datas.map(r => ({
                text: `${r.investigationSiteName}(${r.investigationSiteCode})`,
                value: r.investigationSiteId,
                hospitalName: r.hospitalName,
                hospitalId: r.hospitalId,
                hospitalDepartmentId: r.hospitalDepartmentId ? r.hospitalDepartmentId : '',
            }));
            this.setState({
                data,
            });
        }
    };

    handleSelect = value => {
        this.state.data.map(site => {
            if(site.value == value.key){
                this.props.handleSelectSite(site);
            }
        });
    };

    handleChange = (value) => {
        const { watchValue, handleSiteChange } = this.props;
        watchValue ? watchValue(value) : handleSiteChange(value);
    }

    clearValue = () => {
        this.searchSelectRef.clearValue();
    }

    render() {
        const { allowClear, watchValue } = this.props;
        const { data } = this.state;
        const settings = {};
        allowClear && (settings.allowClear = true);
        watchValue && (settings.watchValue = watchValue);
        return (
            <SearchSelect
                url={API_URL.site.list}
                style={this.props.style}
                searchKey='searchKey'
                searchParam={{}}
                sourceData={data}
                parserData={this.parserData}
                handleSelect = {this.handleSelect}
                onChange = {this.handleChange}
                {...settings}
                ref={el => {this.searchSelectRef = el;}}
            />
        );
    };

}

export default SiteSearchInput;



// WEBPACK FOOTER //
// ./src/components/execute/SiteAutoSearch.js